import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdatePanelSettingEntity } from '../../domain/entities/UpdatePanelSettingEntity'

export class UpdatePanelSettingModel extends UpdatePanelSettingEntity {
  declare showOutOfStockItem: boolean
  declare useCentralizedAutoDispatchFlow: boolean
  declare showCompletedOrderDurationInSecond: number
  declare showCanceledOrderDurationInSecond: number
  declare minimumPrizeCountForSpin: number
  declare userPrizeExpirationTimeInDays: number
  declare userSpinWheelExpirationTimeInHours: number
  declare defaultBranchDistanceCapInKm: number | null
  constructor(dataDto: UpdatePanelSettingEntity) {
    super()
    mapEntityProperties<UpdatePanelSettingModel>(this, dataDto)
  }
}
